module.exports = __webpack_public_path__ + "img/06_maska_romb_1.87c77e4.svg";